export default __webpack_public_path__ + "locales/si/CreateEditRoomDialog.json?hash=3414569c3366c253527d597e9c5e6b91";